export default {"src":"/_next/static/media/html.ed6aaa50.svg","height":290,"width":256,"blurWidth":0,"blurHeight":0};